import {
  LibraryArticleFavorite,
  LibraryArticleFavoriteAddRequest,
  TransformedLibraryArticle,
} from '../types';
import { getArticleImageForUser } from '../utils';

/**
 * Maps a library article to the favorite request payload.
 * Favorites are keyed by `url` (per-user unique), so `contentUrl` is the key.
 */
export const toLibraryArticleFavoriteRequest = (
  article: TransformedLibraryArticle,
): LibraryArticleFavoriteAddRequest => ({
  title: article.title,
  url: article.contentUrl,
  excerpt: article.description,
});

/**
 * Builds the favorited articles list from the favorites API, not the library list,
 * so favorites added from search results (which may not be in the library) still show up.
 * Reuses the matching library article when there is one; otherwise falls back to the
 * favorite's own fields, with a stable placeholder image keyed by url.
 */
export const toFavoritedArticles = (
  favorites: LibraryArticleFavorite[],
  libraryArticles: TransformedLibraryArticle[],
  memberUuid: string,
): TransformedLibraryArticle[] => {
  const libraryArticlesByUrl = new Map(
    libraryArticles.map((article) => [article.contentUrl, article]),
  );

  return favorites.map(
    (favorite) =>
      libraryArticlesByUrl.get(favorite.url) ?? {
        id: favorite.id,
        title: favorite.title,
        description: favorite.excerpt,
        contentUrl: favorite.url,
        contentType: '',
        imageUrl: getArticleImageForUser(memberUuid, favorite.url),
      },
  );
};
